// filters imports
import { EscapeRegexPipe } from './escape-regex';
import { IsTransactionStablePipe } from './is-transaction-stable';
import { PercentagePipe } from './percentage';
import { ProductImagePipe } from './product-image';
import { SkuImagePipe } from './sku-image';
import { SwCurrencyPipe } from './sw-currency';
import { ToNgPromisePipe } from './to-ng-promise';
import { UrlEscapePipe } from './url-escape';

export const filters: any[] = [
  // filters export
  EscapeRegexPipe,
  IsTransactionStablePipe,
  PercentagePipe,
  ProductImagePipe,
  SkuImagePipe,
  SwCurrencyPipe,
  ToNgPromisePipe,
  UrlEscapePipe,
];
